import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToKeyValue'
})
export class ConvertToKeyValuePipe implements PipeTransform {

  transform(data: any): any {
    // Return an empty object if data is null, undefined, or not an object
    if (data === null || data === undefined || typeof data !== 'object') {
      return {};
    }

    // Recursive function to process objects and arrays
    const formatData = (obj: any): any => {
      if (Array.isArray(obj)) {
        // Handle arrays: only return non-empty arrays
        const filteredArray = obj
          .map(item => formatData(item)) // Process each array element recursively
          .filter(item => item !== null && item !== undefined && item !== ''); // Filter out empty or null values

        // Only return the array if it has elements
        return filteredArray.length > 0 ? filteredArray : null;
      } else if (typeof obj === 'object' && obj !== null) {
        // Handle objects: process each key-value pair
        return Object.entries(obj).reduce((acc, [key, value]) => {
          const formattedValue = formatData(value);
          // Only add to the result if the value is non-empty
          if (formattedValue !== null && formattedValue !== undefined && formattedValue !== '') {
            acc[key] = formattedValue;
          }
          return acc;
        }, {});
      }

      // Return non-object (primitive) values as is
      return obj;
    };

    return formatData(data);
  }

}
